"use client";

import React, { useEffect, useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@shared/src/components/ui/avatar";
import { getNetworkIconUrl } from "@sdk/utils/config";
import { useAuthStore } from "@shared/src/stores/useAuthStore";
import { useHostStore } from "@shared/src/stores/useHostStore";

interface NetworkAvatarProps {
  connectorIcon: string;
  size?: "sm" | "md" | "lg";
}

export function NetworkAvatar({ connectorIcon, size = "md" }: NetworkAvatarProps) {
  const { activeChain } = useHostStore();
  const activeAccount = useAuthStore(state => state.activeAccount);

  const IconUrl =
    typeof activeChain?.iconUrl === "string" ? activeChain.iconUrl : getNetworkIconUrl(activeChain?.name || "");

  const avatarSizeClasses = {
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12",
  };

  const connectorAvatarSizeClasses = {
    sm: "!h-3 !w-3",
    md: "!h-4 !w-4",
    lg: "!h-5 !w-5",
  };

  return (
    <div className="flex justify-center items-center gap-2 pr-2 ">
      <div className="relative">
        <Avatar className={avatarSizeClasses[size]}>
          <AvatarImage src={IconUrl} />
          <AvatarFallback>CN</AvatarFallback>
        </Avatar>
        <div className="absolute -bottom-2 left-0.5 bg-surfaces-bg-primary rounded-full p-0.5">
          <Avatar className={connectorAvatarSizeClasses[size]}>
            <AvatarImage sizes="10px" src={connectorIcon} />
            <AvatarFallback>🦊</AvatarFallback>
          </Avatar>
        </div>
      </div>
      <span className="text-sm font-medium ">{activeAccount?.username}</span>
    </div>
  );
}
